import { all, fork, put, select, takeLatest } from 'typed-redux-saga/macro';

import { FETCH_APPLICATION_CONFIGS_SUCCESS } from '../../app/actions';
import { selectConfigEngines } from '../selectors';
import * as Actions from './actions';
import { checkEngineAvailability } from './services';

/**
 * Ask about every engine the language dropdowns could offer.
 *
 * Both maps, because speaker separation is offered per language on the same
 * basis transcription is, and one query for both is one query. The ids are
 * deduped — an org that points two languages at the same engine should not
 * make the query longer.
 */
export function* checkConfiguredEngines() {
  const { transcriptionEngines, speakerSeparationEngines } =
    yield* select(selectConfigEngines);

  const engineIds = [
    ...new Set([
      ...Object.values(transcriptionEngines || {}),
      ...Object.values(speakerSeparationEngines || {}),
    ]),
  ].filter(Boolean);

  yield* put(Actions.CHECK_ENGINE_AVAILABILITY({ engineIds }));
  // The thunk resolves cache-or-fetch and dispatches SUCCESS/FAILURE itself.
  yield* put(checkEngineAvailability(engineIds) as never);
}

/**
 * Triggered by the application configs landing rather than by app boot: the
 * maps are built from them, so before that lands we would be asking about the
 * built-in table alone and would have to ask again. `takeLatest` because the
 * configs are refetched (`REFETCH_APPLICATION_CONFIGS`) and a later answer
 * supersedes an earlier one.
 */
function* onApplicationConfigsLoaded() {
  yield* takeLatest(
    FETCH_APPLICATION_CONFIGS_SUCCESS.type,
    checkConfiguredEngines
  );
}

// configureStore wraps every root saga in keepAlive, so this one does not.
export const saga = function* () {
  yield* all([fork(onApplicationConfigsLoaded)]);
};
